import React, { useEffect, useRef, useState } from "react";
import { components } from "react-select";
import Draggable from "../components/tableComponent/tableComponent/Draggable";
import crossImg from "./../../assets/cross.png";
import Reactselect from "react-select";

const CustomValueContainer = ({ children, ...props }) => {
  const selectedValues = props.getValue();
  const { selectProps, hasValue } = props;
  const handleRemove = (removedValue) => {
    const newValue = selectedValues.filter(
      (val) => val.value !== removedValue.value
    );
    selectProps.onChange(newValue, { action: "remove-value", removedValue });
  };

  return (
    <components.ValueContainer {...props}>
      <div className="drag-tag" onClick={props.selectProps.onMenuOpen}>
        <Draggable showScroll={false}>
          {!hasValue && !props.selectProps.inputValue && (
            <div className="custom-placeholder" style={{ color: "#888888" }}>
              {selectProps.placeholder}
            </div>
          )}
          {selectedValues.map((val) => (
            <span
              className="filter-value"
              key={val.value}
              style={{ marginRight: "8px" }}
            >
              {val.label} {"  "}
              <span className="multiselect-remove">
                <img
                  src={crossImg}
                  onClick={() => handleRemove(val)}
                  width={"13px"}
                />
              </span>
            </span>
          ))}
        </Draggable>
      </div>
    </components.ValueContainer>
  );
};
export default function MutltiselectDropdown({
  label,
  placeholder,
  reactSelectCustomStyles,
  options,
  onChange,
  value,
  id,
  zIndex
}) {
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleClickOutside = (event) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target)
    ) {
      setMenuIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      className="grid-item"
      style={{
        flexBasis: "2.4%",
        fontSize: "14px",
        marginBottom: "10px",
        zIndex: zIndex,
      }}
      id={id}
      ref={dropdownRef}
    >
      <div className="dropdown-label"> {label}</div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          paddingRight: "10px",
        }}
      >
        <Reactselect
          openMenuOnFocus={true}
          menuIsOpen={menuIsOpen}
          onMenuOpen={() => setMenuIsOpen(true)}
          onMenuClose={() => setMenuIsOpen(false)}
          isMulti
          isClearable
          name={placeholder}
          placeholder={placeholder}
          styles={reactSelectCustomStyles}
          options={options}
          components={{ ValueContainer: CustomValueContainer }}
          onChange={onChange}
          value={value}
          classNamePrefix="react-select"
        />
      </div>
    </div>
  );
}
